import BaseButton from "./BaseButton";
import { BaseButtonTypes } from "./types";
type TertiaryButtonProps = Omit<
	BaseButtonTypes,
	| "fontFamily"
	| "fontSize"
	| "shape"
	| "bgColor"
	| "fontColor"
	| "buttonSize"
	| "hoverBackground"
>;
const TertiaryButton: React.FC<TertiaryButtonProps> = (props) => {
	return (
		<BaseButton
			fontFamily="font-omnes"
			fontSize="text-14px"
			shape="rounded-full"
			bgColor="bg-transparent"
			fontColor="text-primarySlightLighter"
			hoverFontColor="hover:text-supply-blue-300 hover:underline"
			additionalClasses="text-nowrap"
			{...props}
		/>
	);
};

export default TertiaryButton;
